<template>
  <div id="resetpassword_wrap">
    <headers/>
    <div id="login_wrap_denglu">
      <div class="login_wrap_denglu_top">重置密码</div>
    </div>
    <div id="resetpassword_form">
      <div class="resetpassword_form_wrap">
        <div class="pinpai_name_password">新密码</div>
        <div class="pinpai_name_input_passwordl">
          <el-input placeholder="请输入密码" v-model="pinpai_name_password" show-password :class="{'mima_jigou':yanzheng_mima_jigou}"></el-input>
        </div>
        <div class="zhuce_password_erro" :class="{'mima_noe':mima_noe}">
          <div class="zhuce_password_erro_con">{{jigou_pass_erro}}</div>
        </div>
        <div class="pinpai_name_password">确认密码</div>
        <div class="pinpai_name_input_passwordl" :class="{'mima_agin':mima_agin}">
          <el-input placeholder="请确认密码" v-model="pinpai_name_password_queren" show-password></el-input>
        </div>
        <div class="affirm_passwor_erro" :class="{'end_pass':end_pass}">
          <div class="affirm_passwor_erro_con">{{affirm_passwor_erro_con}}</div>
        </div>
        <div class="login_wrap_for_enter" @click="sub_test">
          <div class="login_wrap_for_enter_con">下一步</div>
        </div>
      </div>
    </div>
    <footers/>
  </div>
</template>

<script>
import headers from "./header.vue";
import Net_Work from "../apis/network.js";
import footers from "./footers.vue";
import axios from "axios";
import Qs from "qs";
axios.defaults.baseURL = Net_Work.publicApi;
axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;
export default {
  name: "resetpassworld",
  components: { headers,footers },
  data() {
    return {
      pinpai_name_password: "",
      pinpai_name_password_queren: "",
      mima_agin: false,
      mima_noe: true,
      yanzheng_mima_jigou: false,
      my_dbclass_key: null,
      yanzheng_mima_jigou: false,
      jigou_pass_erro: "长度8-16位，必须包含大小写字母和数字",
      affirm_passwor_erro_con: "两次输入密码不一致",
      end_pass: true,
      affirm_password: ""
    };
  },
  methods: {
    sub_test() {
      var _pass = false;
      var _pass_two = false;
      var _this = this;
      var mima_rexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)([^\s]){8,16}$/;
      if (mima_rexp.test(this.pinpai_name_password)) {
        this.affirm_password = this.pinpai_name_password;
        this.yanzheng_mima_jigou = false;
        this.mima_noe = true;
        _pass = true;
      } else {
        this.yanzheng_mima_jigou = true;
        this.mima_noe = false;
      }
      if (_pass) {
        if (this.pinpai_name_password_queren == this.affirm_password) {
          this.mima_agin = false;
          this.end_pass = true;
          _pass_two = true;
        } else {
          this.mima_agin = true;
          this.end_pass = false;
        }
      }
      if (_pass && _pass_two) {
        axios
          .post(
            "/s/api/user/verification/change/password" /*最新代码位置*/,
            Qs.stringify({
              key: _this.my_dbclass_key,
              password: _this.pinpai_name_password,
              password2: _this.pinpai_name_password_queren
            })
          )
          .then(function(response) {
            console.log(response);
            if (response.data.code === 0) {
              _this.$message({
                message: response.data.msg,
                type: "success",
                duration: 1000,
                onClose() {
                  window.sessionStorage.removeItem(
                    "my-dbclass-change-password-key"
                  );
                  _this.$router.push("/password-login");
                }
              });
            } else {
              _this.$message({
                showClose: true,
                message: response.data.msg,
                type: "error"
              });
            }
          })
          .catch(function(error) {});
      }
    }
  },
  created() {
    this.my_dbclass_key = window.sessionStorage.getItem(
      "my-dbclass-change-password-key"
    );
    if (this.my_dbclass_key === null) {
      this.$router.push("/password-login");
    } else {
      
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
#resetpassword_wrap {
  #login_wrap_denglu {
    width: 100%;
    height: 155px;
    overflow: hidden;
    background-color: #eee;
    text-align: center;
    .login_wrap_denglu_top {
      font-family: " MicrosoftYaHei";
      font-size: 30px;
      color: #222743;
      margin-top: 45px;
    line-height: 52px;
    letter-spacing: 1px;
    }
  }
  #resetpassword_form {
    width: 100%;
    padding-bottom: 80px;
    .resetpassword_form_wrap {
      width: 360px;
      height: auto;
      margin: 0 auto;
      margin-top: 36px;
    }
    .affirm_passwor_erro {
      margin-top: 3px;
      .affirm_passwor_erro_con {
        font-size: 12px;
        color: #f56c6c;
        font-family: "MicrosoftYaHei";
        margin-left: 50px;
      }
    }
    .mima_noe {
      visibility: hidden;
    }
    .end_pass {
      visibility: hidden;
    }
    .zhuce_password_erro {
      margin-top: 3px;
      .zhuce_password_erro_con {
        font-size: 12px;
        color: #f56c6c;
        font-family: "MicrosoftYaHei";
        margin-left: 50px;
      }
    }
    .pinpai_name_password {
      font-family: "MicrosoftYaHei";
      font-size: 12px;
      color: #999999;
      margin-top: 20px;
      margin-left: 50px;
    }
    .pinpai_name_input_passwordl {
      width: 260px;
      margin-left: 50px;
      margin-top: 10px;
    }
    .pinpai_name_password {
      font-family: "MicrosoftYaHei";
      font-size: 12px;
      color: #999999;
      margin-top: 20px;
      margin-left: 50px;
    }
    .login_wrap_for_enter {
      margin-left: 50px;
      margin-top: 12px;
      .login_wrap_for_enter_con {
        width: 260px;
        line-height: 30px;
        text-align: center;
        background-color: #3366ff;
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="less">
#resetpassword_wrap {
  .el-input--suffix .el-input__inner {
    height: 30px;
    padding: 0;
    padding-left: 11px;
    display: block;
    margin-right: 11px;
  }
  .el-input__icon {
    line-height: 30px;
  }
  .el-input__inner {
    padding: 0;
    margin: 0;
    width: 100%;
    padding-left: 11px;
    border-radius: 3px;
    height: 30px;
  }
  .mima_jigou .el-input__inner {
    border-color: #f56c6c;
  }
  .mima_agin .el-input__inner {
    border-color: #f56c6c;
  }
  .yanzhengma_bor_btn {
    .el-button:focus,
    .el-button:hover {
      color: #3366ff;
      border-color: #ccc;
      background-color: none;
      background-color: #ffffff;
    }
  }
  .country_select {
    .el-input__inner {
      height: 24px;
    }
    .el-input__icon {
      line-height: 24px;
    }
  }
}
</style>









// WEBPACK FOOTER //
// src/components/resetpassword.vue